( function ( $ ) {

	MP.effects = function(){

		function toggle_box( boxes , tog ,timer ){

			[].forEach.call( boxes , function(box , i){

				var t = i === 0 ? 200 : timer;

				if(box.className.indexOf('slick-cloned') !== -1 ) return;
				setTimeout(function(){
					
					box.classList[tog]('is-effected', 'is-effected--' + ( i + 1 ) );

				} , (i+1) * t);

			});

		}

		var sections = document.querySelectorAll('.js-effects');		

		sections && [].forEach.call ( sections , function ( sect ){

			var boxes = sect.querySelectorAll('.js-effect-child'),
				flag = true,
				effect_gap = parseInt( sect.getAttribute('data-effectgap') ) || 300;
			

			boxes.length && lib.on ( ['load', 'scroll'] , function () {

				if ( lib.isScrolledIntoView ( sect , 0 ) && flag ) {
					
					toggle_box(boxes,'add',effect_gap);
					flag = false;

				} 
				 
				if ( ! lib.isScrolledIntoView ( sect , 0 ) && ! flag ) {
			
					//toggle_box(boxes,'remove',0);
					flag = true;
					
				}
			},0);

		});

	};

	MP.parallax = function(){

		if( browser.fuie ) return; // parallax looks bad in i.e.
		
		var parallax_bg = document.querySelectorAll('.js-parallax[style^="background"]'),
			parallax_x = document.querySelectorAll('.js-parallax-x');

		parallax_bg.length && [].forEach.call( parallax_bg , function( el ){
			
			lib.on(['load','scroll'] , function(){

				var formula = window.pageYOffset;
				var cool = formula * 0.6;
				el.style.backgroundPositionY = cool+"px";

			});

		});		

		parallax_x.length && [].forEach.call( parallax_x , function( el ){

			lib.on(['load','scroll'] , function(){

				var formula = window.pageYOffset;
				var cool = -formula * 0.2;
				var pos = lib.ltr() ? 'left' : 'right';
				el.style[pos] = cool+"px"; 

			});

		});		

	};

	MP.mobile_bg_change = function(){

		var els = document.querySelectorAll('[data-bgmobile]');

		if ( ! els.length ) return;

		[].forEach.call( els, function (el){
			
			var bg_desktop = el.style.backgroundImage,
				bg_mobile = el.getAttribute('data-bgmobile');
			
			if ( ! bg_mobile ) return;
			
			bg_mobile = 'url(' + bg_mobile + ')';

			lib.on('resize',function(){
				if ( lib.viewport().width <= mobile ){
					el.style.backgroundImage = bg_mobile;
				} else {
					el.style.backgroundImage = bg_desktop;
				}
			});

		});
	};

	MP.icons = function(){

		var els = document.querySelectorAll('[data-icon]');

		if ( ! els.length ) return;

		$(els).each(function(){

			var el = $(this);

			var icon_name = el.data('icon');

			el.html( 
				'<span class="l-center">' +
					'<i class="t-bullet svgIcon icon-' + icon_name + '"></i>' +
					'<span class="text">' + el.text() + '</span>' +
				'</span>');
							
		});		

	};

	MP.you_save = function(){
		$('[data-save]').each( function(){
			var $it = $(this),
				text = $it.data('save');
				
			$it.
			addClass( 'choose-package-parice-patch' ).
			attr('aria-label',text).
			html(`

				<i class="l-spread choose-package-parice-bg">${new SvgIcons().render( 'b-patch-empty' ) }</i>
			
				<span class="h100 l-center l-layer-up">
					<span class="t-line-height">
						<span class="l-center f-b package-save-top">
							<small class="package-save-operator">%</small>
							<strong class="package-save-amount">${text}</strong>
						</span>
						<span class="fs-small fw-light package-save-text">חיסכון</span>
					</span>
				</span>
			
			`)
		});
	};

	MP.decorations = function(){
		$('.faq-icon-sign').scaleToParent( 20/37 );
	};

}) ( window.jQuery);


// WEBPACK FOOTER //
// ./assets/js/c-effects.c-decorations.js